var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data.length > 0)?_c('custom-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"pagination":_vm.pagination,"walletId":_vm.wallet.id},on:{"change":_vm.moveOn}}):_c('a-empty')],1)}
var staticRenderFns = []

export { render, staticRenderFns }